var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import 'component/alertCustomSweetAlert/customSweetAlert.scss';
function CustomSweetAlert(props) {
    var title = props.title, onConfirm = props.onConfirm, onCancel = props.onCancel, children = props.children, success = props.success, danger = props.danger, timeout = props.timeout, rest = __rest(props, ["title", "onConfirm", "onCancel", "children", "success", "danger", "timeout"]);
    return (React.createElement(SweetAlert, __assign({}, rest, { success: success, danger: danger, title: title, onConfirm: onConfirm, onCancel: onCancel, showConfirm: false, timeout: timeout || timeout === 0 ? timeout : 3000 }), children));
}
export default CustomSweetAlert;
